var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLanguageIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 28,
    viewBox: "0 0 36 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 4534579"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4534578"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_d_586_180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.257 18.1723C32.0966 18.7539 31.8832 19.3195 31.6193 19.8621C31.2856 20.4765 30.8007 20.9957 30.2105 21.3705C29.6203 21.7454 28.9442 21.9637 28.2462 22.0046L27.9848 22.0428C28.0358 22.5466 28.0804 23.0439 28.1442 23.5413C28.2008 23.7599 28.1927 23.9902 28.1209 24.2044C28.0492 24.4185 27.9169 24.6072 27.7401 24.7476C27.5632 24.888 27.3494 24.974 27.1246 24.9953C26.8998 25.0167 26.6737 24.9723 26.4736 24.8676C25.243 24.4109 24.2358 23.4974 23.6615 22.317C23.6242 22.2239 23.5569 22.1458 23.4704 22.095C23.3838 22.0442 23.2828 22.0236 23.1833 22.0364C21.6912 22.0364 20.1991 22.0747 18.7198 22.0364C17.6889 21.9652 16.7193 21.5206 15.9927 20.7858C15.2661 20.051 14.8323 19.0765 14.7727 18.0448C14.7281 17.0947 14.7727 16.1319 14.7727 15.1818V14.7545H14.4029C13.1786 14.7545 11.9607 14.7545 10.7365 14.7545C10.646 14.7421 10.5541 14.7613 10.4762 14.809C10.3983 14.8566 10.3393 14.9298 10.3092 15.016C9.73362 16.2218 8.70793 17.1536 7.45258 17.6112C7.25456 17.7099 7.03252 17.7499 6.81252 17.7266C6.59252 17.7032 6.38372 17.6175 6.21083 17.4794C6.03795 17.3414 5.90814 17.1568 5.83667 16.9474C5.7652 16.738 5.75508 16.5126 5.80748 16.2977C5.87124 15.8003 5.91588 15.2966 5.96689 14.8247C5.48042 14.7292 4.99938 14.6079 4.52581 14.4612C3.72305 14.1671 3.02738 13.6383 2.52928 12.9434C2.03117 12.2486 1.75369 11.4199 1.73292 10.5652C1.73292 8.79897 1.70104 7.02631 1.73292 5.26004C1.73956 4.69233 1.85826 4.13153 2.08225 3.60984C2.30625 3.08816 2.63113 2.61584 3.03818 2.22006C3.44522 1.82427 3.92643 1.5128 4.4542 1.30352C4.98196 1.09424 5.54587 0.991298 6.11354 1.00058C9.88839 1.00058 13.6633 1.00058 17.4381 1.00058C17.8431 1.00471 18.246 1.06039 18.6369 1.16633C19.5295 1.40219 20.322 1.92005 20.8965 2.64275C21.471 3.36545 21.7967 4.25436 21.8251 5.17714C21.8251 6.10173 21.8251 7.02629 21.8251 7.9445V8.32073H22.1885C24.1015 8.32073 25.9634 8.32073 27.8508 8.32073C28.8531 8.30475 29.8298 8.63752 30.6137 9.26213C31.3977 9.88675 31.9402 10.7644 32.1485 11.7449C32.1485 11.8788 32.2123 12.0063 32.2442 12.1402L32.257 18.1723ZM26.9836 23.7709V23.6305C26.9326 22.9355 26.8689 22.2469 26.837 21.5518C26.837 21.0608 27.0538 20.8504 27.5448 20.8377H27.8126C28.2448 20.8465 28.6742 20.7674 29.0749 20.6051C29.4756 20.4428 29.839 20.2007 30.1432 19.8935C30.4474 19.5864 30.6859 19.2206 30.8443 18.8184C31.0027 18.4161 31.0776 17.9859 31.0646 17.5538C31.0646 15.9554 31.0646 14.355 31.0646 12.7524C31.0844 12.3169 31.0135 11.8821 30.8563 11.4756C30.6991 11.0691 30.459 10.6996 30.1514 10.3908C29.8438 10.082 29.4753 9.84054 29.0694 9.68175C28.6634 9.52297 28.229 9.45035 27.7935 9.46848H19.9249C19.4913 9.46848 19.2172 9.22617 19.2108 8.86909C19.2044 8.51201 19.485 8.28246 19.9186 8.27609H20.6455V6.20374C20.6647 5.74855 20.6519 5.29257 20.6072 4.83917C20.5022 4.07489 20.1188 3.3763 19.5304 2.87735C18.942 2.37841 18.1901 2.11425 17.419 2.13556H9.46756C8.29429 2.13556 7.12101 2.13556 5.94774 2.13556C5.1655 2.16185 4.42175 2.48136 3.86419 3.03066C3.30663 3.57995 2.97605 4.31886 2.93808 5.10063C2.89982 6.90516 2.93808 8.71607 2.93808 10.5206C2.96869 11.1859 3.21283 11.8237 3.63433 12.3394C4.05584 12.8551 4.63225 13.2212 5.27818 13.3836C5.68675 13.4561 6.10039 13.4967 6.51526 13.5048C6.90422 13.5048 7.1529 13.728 7.1529 14.1042C7.1529 14.4804 7.15287 14.9012 7.12099 15.2966C7.08911 15.6919 7.04451 16.0362 6.99987 16.4315L7.14652 16.3869C7.66574 16.1831 8.13624 15.8722 8.52736 15.4745C8.91847 15.0768 9.22146 14.6012 9.41657 14.0786C9.61424 13.5813 9.72899 13.5048 10.2646 13.5048H14.7281V12.7587C14.7152 11.9891 14.8949 11.2285 15.251 10.5461C15.2899 10.4377 15.3635 10.3453 15.4603 10.283C15.5572 10.2208 15.6719 10.1922 15.7866 10.2018C15.9857 10.2371 16.1661 10.3408 16.2967 10.4951C16.4689 10.6927 16.386 10.9414 16.2967 11.1327C16.0507 11.6341 15.9304 12.1878 15.946 12.746C15.946 14.3273 15.946 15.9023 15.946 17.4837C15.9419 17.7423 15.9633 18.0008 16.0098 18.2552C16.1589 18.9862 16.5595 19.6418 17.142 20.1078C17.7246 20.5739 18.4522 20.8209 19.198 20.8058C20.6008 20.8058 22.0036 20.8058 23.4001 20.8058C23.6784 20.7619 23.9631 20.8231 24.1988 20.9775C24.4346 21.1318 24.6044 21.3684 24.6754 21.6411C24.8788 22.1435 25.1906 22.5949 25.5885 22.963C25.9864 23.3311 26.4606 23.607 26.9773 23.7709H26.9836Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2",
    filter: "url(#filter1_d_586_180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2149 8.07188C11.728 7.42847 12.0976 6.68276 12.2989 5.88476H11.9546H8.53043C8.04582 5.88476 7.76521 5.65521 7.77159 5.24712C7.77797 4.83902 8.04581 4.66687 8.51766 4.66049H10.2776H10.6092C10.6092 4.31616 10.6091 3.99097 10.6665 3.66577C10.6836 3.53619 10.7475 3.41731 10.8462 3.33157C10.9448 3.24584 11.0714 3.19914 11.2021 3.20026C11.3265 3.18713 11.4516 3.21743 11.5562 3.286C11.6608 3.35457 11.7385 3.4572 11.776 3.57649C11.8167 3.71065 11.8318 3.85124 11.8206 3.99097C11.8206 4.20777 11.8206 4.42454 11.8206 4.67322H13.0959C13.4657 4.67322 13.8293 4.67322 14.1991 4.67322C14.3332 4.68761 14.4569 4.7521 14.5456 4.85376C14.6342 4.95542 14.6813 5.08679 14.6773 5.22162C14.6838 5.36111 14.6385 5.49807 14.5502 5.6063C14.462 5.71453 14.337 5.78643 14.1991 5.80825H14.0779C13.893 5.80825 13.6571 5.80824 13.5423 5.87838C13.4275 5.94852 13.4339 6.22272 13.3765 6.40763C13.1379 7.18661 12.7693 7.91959 12.2862 8.5756L12.0056 8.97098L13.8675 10.31C14.0014 10.412 14.1608 10.4822 14.2947 10.5778C14.3635 10.6179 14.4236 10.6713 14.4715 10.7349C14.5194 10.7985 14.5542 10.871 14.5738 10.9482C14.5934 11.0253 14.5974 11.1056 14.5856 11.1844C14.5739 11.2631 14.5465 11.3387 14.5052 11.4067C14.4652 11.4759 14.411 11.5359 14.3462 11.5827C14.2814 11.6296 14.2075 11.6621 14.1292 11.6784C14.0509 11.6947 13.9702 11.6942 13.8921 11.6771C13.814 11.6599 13.7404 11.6265 13.6762 11.5789C12.9493 11.0943 12.2479 10.5778 11.5401 10.0741C11.4424 9.996 11.3487 9.91299 11.2595 9.8254C10.743 10.2207 10.2457 10.6097 9.73559 10.9795C9.45502 11.1836 9.15533 11.3621 8.85563 11.5407C8.78769 11.5936 8.70968 11.6322 8.6264 11.6542C8.54313 11.6762 8.45631 11.6811 8.3711 11.6686C8.28588 11.656 8.2041 11.6264 8.13066 11.5814C8.05721 11.5364 7.99362 11.477 7.94377 11.4067C7.75247 11.0815 7.86724 10.7691 8.24982 10.5077C8.88747 10.0613 9.52511 9.58949 10.1628 9.13039C10.2344 9.07518 10.3006 9.01323 10.3605 8.94545C10.048 8.42258 9.72279 7.91886 9.4486 7.40874C9.37889 7.30983 9.3415 7.19177 9.3415 7.07077C9.3415 6.94977 9.37889 6.83175 9.4486 6.73284C9.50456 6.63605 9.59231 6.56157 9.6969 6.52205C9.80149 6.48254 9.91651 6.48041 10.0225 6.51602C10.214 6.60329 10.379 6.73969 10.5007 6.91136C10.794 7.3067 10.9981 7.68291 11.2149 8.07188Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3",
    filter: "url(#filter2_d_586_180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4901 16.9719C22.3881 17.329 22.286 17.667 22.2031 18.0113C22.1953 18.066 22.1768 18.1186 22.1484 18.166C22.12 18.2134 22.0824 18.2547 22.0378 18.2873C21.9933 18.32 21.9426 18.3435 21.8889 18.3563C21.8351 18.3691 21.7794 18.371 21.7249 18.362C21.5477 18.3467 21.3738 18.3059 21.2084 18.2408C20.8258 18.0814 20.7557 17.9156 20.8704 17.5203L22.4582 12.3171C22.5098 12.1084 22.6383 11.9268 22.8179 11.8086C22.9976 11.6904 23.2152 11.6443 23.4274 11.6795C23.9949 11.6795 24.2818 11.858 24.4285 12.3171L26.0162 17.5203C26.1373 17.9029 26.0672 18.0687 25.7038 18.2281C25.5306 18.2969 25.3477 18.3378 25.1618 18.3492C25.1076 18.3592 25.052 18.3582 24.9983 18.3461C24.9446 18.3341 24.8939 18.3113 24.8492 18.2791C24.8045 18.2469 24.7668 18.2061 24.7383 18.159C24.7099 18.1118 24.6912 18.0594 24.6835 18.0049C24.6134 17.7116 24.5433 17.4246 24.4476 17.1441C24.4281 17.1006 24.3981 17.0627 24.3602 17.0338C24.3224 17.0048 24.2779 16.9858 24.2308 16.9783C23.657 16.9656 23.0831 16.9719 22.4901 16.9719ZM24.0969 15.8624L23.4592 13.5669H23.3955L22.7578 15.8688L24.0969 15.8624Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_4",
    filter: "url(#filter3_d_586_180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9936 9.26383C17.9833 9.41666 17.9184 9.56067 17.8106 9.66956C17.7029 9.77845 17.5596 9.84493 17.4069 9.85684C17.2513 9.85684 17.1021 9.79503 16.9921 9.68501C16.8821 9.575 16.8203 9.4258 16.8203 9.27022C16.8203 9.11463 16.8821 8.96544 16.9921 8.85542C17.1021 8.7454 17.2513 8.68359 17.4069 8.68359C17.5576 8.69511 17.6993 8.75977 17.8067 8.86604C17.9142 8.97232 17.9804 9.11328 17.9936 9.26383Z"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_586_180",
    x: 0.71875,
    y: 0,
    width: 34.5381,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_586_180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_586_180",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_586_180",
    x: 6.77148,
    y: 2.19727,
    width: 10.9062,
    height: 12.4922,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_586_180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_586_180",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_586_180",
    x: 19.8203,
    y: 10.668,
    width: 9.25049,
    height: 10.6992,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_586_180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_586_180",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_586_180",
    x: 15.8203,
    y: 7.68359,
    width: 5.17334,
    height: 5.17383,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_586_180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_586_180",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageIcon);
export default __webpack_public_path__ + "static/media/languageIcon.7cedd724.svg";
export { ForwardRef as ReactComponent };